<template>
  <div id="app" class="container-fluid">
    <div class="row min-h-100">
      <ci-sidebar class="min-h-100" v-if="$store.getters.isUserLoggedIn">
        <ci-navigation-main/>
      </ci-sidebar>
      <div :class="getContainerClasses">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationMain from '@/components/navigation/NavigationMain.vue';
import Sidebar from '@/components/Sidebar.vue';

export default {
  name: 'App',

  components: {
    'ci-navigation-main': NavigationMain,
    'ci-sidebar': Sidebar,
  },

  computed: {
    getContainerClasses() {
      const classes = ['min-h-100'];

      if (this.$store.getters.isUserLoggedIn) {
        classes.push('col-xl-10');
      } else {
        classes.push('col-12');
      }

      return classes.join(' ');
    },
  },
};
</script>

<style lang="scss">
@import "@/scss/admin.scss";
</style>
